import React, { useState, useEffect, useRef } from 'react';
import classNames from 'classnames';
import { questionValidation } from '../../functions/Validation';
import QuestionHelp from '../question/QuestionHelp';
import ValidationMessage from '../question/ValidationMessage';
import { tracking } from '../../functions/Tracking';
import { Action } from '../../enums/TrackingActionType';

export default function TextBox(props: any) {

    const [question, setQuestion] = useState(props.question);
    const [textValue, setTextValue] = useState(question.answer);
    const [secondsFocused, setSecondsFocused] = useState(0);
    const timerId = useRef<number>(0);
    const inputRef = useRef(question.questionSetQuestion.questionID);

    var inputClasses = classNames(
        {
            'validation-fail': question.validationFail,
            'text-input': true,
            'short-form-question': question.page === 0
        }
    );

    var labelClasses = classNames(
        {
            'validation-fail-lbl': question.validationFail
        }
    );

    useEffect(() => {
        setQuestion(props.question);
        if (props.question.answer) {
            setTextValue(props.question.answer);
        }

        document.addEventListener("updateAnswer", function (e) {
            let eventDetails: any = e;
            if (eventDetails.detail.questionID === question.questionSetQuestion.questionID) {
                setTextValue(eventDetails.detail.answer);
            }
        });


        document.addEventListener("updateAnswerAtIndex", function (e) {
            let eventDetails: any = e;
            if (eventDetails.detail.questionID === question.questionSetQuestion.questionID && eventDetails.detail.index == question.index) {
                setTextValue(eventDetails.detail.answer);
                question.validationFail = false;
                setQuestion(question);
            }
        });
    }, []);

    useEffect(() => {
        if (secondsFocused === 60) {
            //alert("Too much time has passed");
            //alert(question.questionSetQuestion.text);
        }
    }, [secondsFocused]);

    useEffect(() => {
        question.answer = textValue;
        setQuestion(question);

        // this fires the functions when the value has changed but the input isn't currently focused i.e. on browser autocomplete
        if (document.activeElement !== inputRef.current) {
            props.setIndividualCustomerDetails(question);
            props.enableQuestions(question.questionSetQuestion.questionID);
        }
        
    }, [textValue])

    useEffect(() => {
        setTextValue(props.question.answer)
    }, [props.question.answer]);

    const startTimer = () => {
        timerId.current = window.setInterval(() => {
            setSecondsFocused(prev => prev + 1);
        }, 1000)
    };

    const stopTimer = () => {
        window.clearInterval(timerId.current);
        setSecondsFocused(0);
    };

    const updateAnswer = (e: React.ChangeEvent<HTMLInputElement>) => {
        setTextValue(e.target.value);
    };

    const validateAnswer = () => {
        stopTimer();
        tracking(Action.SAVE_QUESTIONS, question.questionSetQuestion.questionID);
        question.validationFail = !questionValidation(question);
        props.setIndividualCustomerDetails(question);
        props.enableQuestions(question.questionSetQuestion.questionID);
        setQuestion(question);
    };

    return (
        <>
            <div className="question">
                <label className={labelClasses} htmlFor={"valen_" + question.questionSetQuestion.questionID}>{question.questionSetQuestion.text}</label>
                <br />
                <input
                    type="text"
                    value={textValue}
                    id={"valen_" + question.questionSetQuestion.questionID}
                    className={inputClasses}
                    onChange={(e) => updateAnswer(e)}
                    onFocus={() => startTimer()}
                    onBlur={() => validateAnswer()}
                    maxLength={question.questionSetAnswerType.length}
                    ref={inputRef}
                    placeholder={question.placeholder}
                />
                {question.questionSetQuestion.helpText !== null && question.questionSetQuestion.helpText !== "" &&
                    <QuestionHelp helpText={question.questionSetQuestion.helpText} questionID={question.questionSetQuestion.questionID} />
                }
                {question.validationFail &&
                    <ValidationMessage question={question} overrideMessage="" />}
                    {/*<p>Focused: {secondsFocused}</p>*/}
            </div>
        </>

    );
};